import React, { useState } from 'react';
import { XIcon, MailIcon, InfoIcon, PlusIcon, TrashIcon } from 'lucide-react';
interface BrokerInviteModalProps {
  onClose: () => void;
  onSave: (brokerData: any) => void;
  truckTypes: string[];
}
export const BrokerInviteModal = ({
  onClose,
  onSave,
  truckTypes
}: BrokerInviteModalProps) => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    status: 'pending',
    defaultRate: 100,
    sendInvite: true,
    includeContract: true,
    customMessage: ''
  });
  const [customTrucks, setCustomTrucks] = useState<string[]>([]);
  const [newTruckType, setNewTruckType] = useState('');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value,
      type
    } = e.target;
    const checked = type === 'checkbox' ? (e.target as HTMLInputElement).checked : undefined;
    if (type === 'checkbox') {
      setFormData(prev => ({
        ...prev,
        [name]: checked
      }));
    } else if (name === 'defaultRate') {
      setFormData(prev => ({
        ...prev,
        [name]: parseFloat(value) || 0
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };
  const handleAddCustomTruck = () => {
    if (newTruckType && !truckTypes.includes(newTruckType) && !customTrucks.includes(newTruckType)) {
      setCustomTrucks([...customTrucks, newTruckType]);
      setNewTruckType('');
    }
  };
  const handleRemoveCustomTruck = (truckType: string) => {
    setCustomTrucks(customTrucks.filter(t => t !== truckType));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto" data-id="element-1227">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl my-8 flex flex-col max-h-[90vh]" data-id="element-1228">
        <div className="flex items-center justify-between p-4 border-b sticky top-0 bg-white z-10" data-id="element-1229">
          <h3 className="text-lg font-medium" data-id="element-1230">Add New Broker</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700" type="button" data-id="element-1231">
            <XIcon size={20} data-id="element-1232" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="flex flex-col h-full" data-id="element-1233">
          <div className="p-6 overflow-y-auto flex-grow" data-id="element-1234">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-1235">
              <div data-id="element-1236">
                <label className="block text-sm font-medium mb-1" data-id="element-1237">
                  Broker Name
                </label>
                <input type="text" name="name" value={formData.name} onChange={handleChange} className="w-full border border-gray-300 rounded-md p-2" placeholder="John Smith" required data-id="element-1238" />
              </div>
              <div data-id="element-1239">
                <label className="block text-sm font-medium mb-1" data-id="element-1240">
                  Company
                </label>
                <input type="text" name="company" value={formData.company} onChange={handleChange} className="w-full border border-gray-300 rounded-md p-2" placeholder="ABC Trucking" required data-id="element-1241" />
              </div>
              <div data-id="element-1242">
                <label className="block text-sm font-medium mb-1" data-id="element-1243">Email</label>
                <input type="email" name="email" value={formData.email} onChange={handleChange} className="w-full border border-gray-300 rounded-md p-2" placeholder="john@example.com" required data-id="element-1244" />
              </div>
              <div data-id="element-1245">
                <label className="block text-sm font-medium mb-1" data-id="element-1246">Phone</label>
                <input type="tel" name="phone" value={formData.phone} onChange={handleChange} className="w-full border border-gray-300 rounded-md p-2" placeholder="555-123-4567" required data-id="element-1247" />
              </div>
            </div>
            <div className="mb-4" data-id="element-1248">
              <label className="block text-sm font-medium mb-1" data-id="element-1249">
                Default Rate ($/hour)
              </label>
              <div className="flex items-center" data-id="element-1250">
                <span className="px-3 py-2 bg-gray-100 border border-r-0 border-gray-300 rounded-l-md" data-id="element-1251">
                  $
                </span>
                <input type="number" name="defaultRate" value={formData.defaultRate} onChange={handleChange} className="w-full border border-gray-300 rounded-r-md p-2" min="0" step="0.01" required data-id="element-1252" />
              </div>
              <p className="text-xs text-gray-500 mt-1" data-id="element-1253">
                This rate will be used as the default for all truck types. You
                can customize rates per truck type later.
              </p>
            </div>
            <div className="mb-4" data-id="element-1254">
              <h4 className="text-sm font-medium mb-2" data-id="element-1255">
                Truck Types Available
              </h4>
              <div className="mb-2 grid grid-cols-2 gap-2" data-id="element-1256">
                {truckTypes.map(type => <div key={type} className="flex items-center" data-id="element-1257">
                    <input type="checkbox" id={`truck-${type}`} checked={true} disabled className="mr-2" data-id="element-1258" />
                    <label htmlFor={`truck-${type}`} data-id="element-1259">{type}</label>
                  </div>)}
                {customTrucks.map(type => <div key={type} className="flex items-center justify-between bg-gray-50 p-2 rounded" data-id="element-1260">
                    <span data-id="element-1261">{type}</span>
                    <button type="button" onClick={() => handleRemoveCustomTruck(type)} className="text-red-500 hover:text-red-700" data-id="element-1262">
                      <TrashIcon size={16} data-id="element-1263" />
                    </button>
                  </div>)}
              </div>
              <div className="flex items-center mt-2" data-id="element-1264">
                <input type="text" value={newTruckType} onChange={e => setNewTruckType(e.target.value)} className="flex-grow border border-gray-300 rounded-l-md p-2" placeholder="Add custom truck type" data-id="element-1265" />
                <button type="button" onClick={handleAddCustomTruck} className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded-r-md" data-id="element-1266">
                  <PlusIcon size={18} data-id="element-1267" />
                </button>
              </div>
            </div>
            <div className="mb-4 p-4 bg-blue-50 rounded-md" data-id="element-1268">
              <h4 className="text-sm font-medium mb-2 flex items-center" data-id="element-1269">
                <MailIcon size={16} className="mr-1" data-id="element-1270" />
                Invitation Options
              </h4>
              <div className="mb-2" data-id="element-1271">
                <label className="flex items-center" data-id="element-1272">
                  <input type="checkbox" name="sendInvite" checked={formData.sendInvite} onChange={handleChange} className="mr-2" data-id="element-1273" />
                  Send email invitation to broker
                </label>
              </div>
              <div className="mb-2" data-id="element-1274">
                <label className="flex items-center" data-id="element-1275">
                  <input type="checkbox" name="includeContract" checked={formData.includeContract} onChange={handleChange} className="mr-2" data-id="element-1276" />
                  Include broker agreement contract
                </label>
              </div>
              <div data-id="element-1277">
                <label className="block text-sm mb-1" data-id="element-1278">
                  Custom Message (Optional)
                </label>
                <textarea name="customMessage" value={formData.customMessage} onChange={handleChange} rows={2} className="w-full border border-gray-300 rounded-md p-2" placeholder="Add a personal message to your invitation..." data-id="element-1279"></textarea>
              </div>
            </div>
            <div className="flex items-start gap-2 text-sm text-gray-600 bg-gray-50 p-3 rounded-md" data-id="element-1280">
              <InfoIcon size={18} className="text-gray-500 flex-shrink-0 mt-0.5" data-id="element-1281" />
              <div data-id="element-1282">
                <p data-id="element-1283">
                  After adding a broker, you'll be able to customize rates for
                  each truck type and send a formal agreement.
                </p>
              </div>
            </div>
          </div>
          <div className="border-t px-6 py-4 flex justify-end gap-3 sticky bottom-0 bg-white z-10" data-id="element-1284">
            <button type="button" onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-1285">
              Cancel
            </button>
            <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" data-id="element-1286">
              Add Broker
            </button>
          </div>
        </form>
      </div>
    </div>;
};